import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';

import SymbolEdit from 'assets/SymbolEdit';
import CheckIcon from 'assets/CheckIcon';
import CloseIcon from 'assets/ClientCloseIcon';


const styles = {
  wrapper: {
    marginLeft: '5px',
    display: 'flex',
  },
  button: {
    borderRadius: '50%',
    width: '25px',
    height: '25px',
  },
  editButton: {
    backgroundColor: '#A7B6DB',
    ':hover': {
      backgroundColor: '#3D568F',
    },
  },
  saveButton: {
    backgroundColor: '#F04D4D',
    marginRight: '5px',
  },
  cancelButton: {
    backgroundColor: '#E14E52',
  },
};

class MessageEditControls extends Component {
  constructor(props) {
    super(props);
    this.state = {
      saving: false,
    };
  }

  handleSave = () => {
    this.setState({
      saving: true,
    });
    const { handleSave } = this.props;
    handleSave().finally(() => {
      this.setState({
        saving: false,
      });
    });
  };

  render() {
    const {
      editing, handleEditIconClick, handleCancel,
    } = this.props;

    const { saving } = this.state;

    if (editing) {
      return (
        <div style={styles.wrapper}>
          <button
            disabled={saving}
            type="button"
            className="no-style-button centered-flex-container"
            style={[styles.button, styles.saveButton]}
            onClick={this.handleSave}
          >
            <CheckIcon fill="#FFFFFF" width="15px" height="15px" />
          </button>
          <button
            disabled={saving}
            type="button"
            className="no-style-button centered-flex-container"
            style={[styles.button, styles.cancelButton]}
            onClick={handleCancel}
          >
            <CloseIcon fill="#FFFFFF" width="15px" height="15px" />
          </button>
        </div>);
    }

    return (
      <div style={styles.wrapper}>
        <button
          type="button"
          className="no-style-button centered-flex-container"
          style={[styles.button, styles.editButton]}
          onClick={handleEditIconClick}
        >
          <SymbolEdit fill="#FFFFFF" width="15px" height="15px" />
        </button>
      </div>);
  }
}

MessageEditControls.propTypes = {
  editing: PropTypes.bool.isRequired,
  handleEditIconClick: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired,
  handleSave: PropTypes.func.isRequired,
};

export default Radium(MessageEditControls);



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/MessageEditControls.jsx